export const NSW = 'New South Wales';
export const VIC = 'Victoria';
export const QLD = 'Queensland';
export const WA = 'Western Australia';
export const SA = 'South Australia';
export const TAS = 'Tasmania';
export const ACT = 'Australian Capital Territory';
export const NT = 'Northern Territory';
export const AUS = 'National';
